import FiscalSpedFiscalService from "@/services/FiscalSpedFiscalService";

export const fiscalSpedFiscal = {
  namespaced: true,
  state: {},
  actions: {
    getFiscalSpedFiscalJobsOData(_, payload) {
      return FiscalSpedFiscalService.GetJobsOData(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error)
      );
    },
    postFiscalSpedFiscalJob(_, payload) {
      return FiscalSpedFiscalService.PostJob(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    deleteFiscalSpedFiscalJob(_, payload) {
      return FiscalSpedFiscalService.DeleteJob(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    downloadFiscalSpedFiscalJob(_, payload) {
      return FiscalSpedFiscalService.DownloadJob(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error)
      );
    },
    getFiscalSpedFiscalFiltros() {
      return FiscalSpedFiscalService.GetFiltros().then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    getFiscalSpedFiscalConfiguracoes() {
      return FiscalSpedFiscalService.GetConfiguracoes().then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    putFiscalSpedFiscalConfiguracoes(_, payload) {
      return FiscalSpedFiscalService.PutConfiguracoes(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    getFiscalSpedFiscalBlocoKEstoques() {
      return FiscalSpedFiscalService.GetBlocoKEstoques().then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    getFiscalSpedFiscalBlocoKEstoque(_, id) {
      return FiscalSpedFiscalService.GetBlocoKEstoque(id).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    processarFiscalSpedFiscalBlocoKEstoque(_, payload) {
      return FiscalSpedFiscalService.ProcessarBlocoKEstoque(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    postFiscalSpedFiscalBlocoKEstoque(_, payload) {
      return FiscalSpedFiscalService.PostBlocoKEstoque(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
  },
  mutations: {},
};

export default fiscalSpedFiscal;
